import styled from 'styled-components'

export const ALink = styled.a`
  color: blue;
  text-decoration: underline;
`